package fr.frux.feature.map.aim

import fr.frux.shared.domain.model.Tree

/** En visee, la selection est le voisin candidat au doublon, pas celle de l'ecran. */
internal fun MapAimState.markerSelection(screenSelection: Long?): Long? =
    if (isActive) candidate?.tree?.id else screenSelection

/**
 * Les evenements camera du ViewModel (cadrage d'Explorer, recentrage) recadreraient la carte sous
 * l'epingle : ils sont ignores pendant la visee.
 */
internal fun MapAimState.allowsViewModelCameraEvents(): Boolean = !isActive

/** Les gestes de la visee n'alimentent ni la requete d'arbres ni la vue memorisee. */
internal fun MapAimState.allowsCameraTracking(): Boolean = !isActive

/** Pendant la visee, l'arbre deplace n'est pas un marqueur : le cercle dessine sa position actuelle. */
internal fun MapAimState.markerTrees(trees: List<Tree>): List<Tree> =
    if (isActive && excludedTreeId != null) trees.filterNot { it.id == excludedTreeId } else trees
